module.exports = __webpack_public_path__ + "static/media/30.b4011d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/30.png
// module id = 1137
// module chunks = 0